module.exports = __webpack_public_path__ + "static/media/main_01.c7c99e54.png";